import { createSelector } from 'reselect'

import { PeriodsRootState } from '../models'

const getPeriodsState = (state: PeriodsRootState) => state?.periods

export const getPeriod = createSelector([getPeriodsState], (state) => state?.single?.data)
